import { useEffect } from "react";


const SITE_URL = "https://aerocorescripts.com";

const setMeta = (selector, attributes, content) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const PageMeta = ({ title, description, path = "/", noindex = false, image = "/aerocore-logo-v2.svg" }) => {
  useEffect(() => {
    const fullTitle = title.includes("AeroCore") ? title : `${title} | AeroCore Scripts`;
    const url = `${SITE_URL}${path}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', { name: "description" }, description);
    setMeta('meta[name="robots"]', { name: "robots" }, noindex ? "noindex,nofollow" : "index,follow");
    setMeta('meta[property="og:title"]', { property: "og:title" }, fullTitle);
    setMeta('meta[property="og:description"]', { property: "og:description" }, description);
    setMeta('meta[property="og:url"]', { property: "og:url" }, url);
    setMeta('meta[property="og:image"]', { property: "og:image" }, `${SITE_URL}${image}`);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [description, image, noindex, path, title]);

  return null;
};

export default PageMeta;
